// Generated from ESF schema: governance
// Do not edit manually!
/** Status of a governance proposal */
export var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["Pending"] = "pending";
    ProposalStatus["Approved"] = "approved";
    ProposalStatus["Executed"] = "executed";
    ProposalStatus["Rejected"] = "rejected";
    ProposalStatus["Expired"] = "expired";
    ProposalStatus["Cancelled"] = "cancelled";
})(ProposalStatus || (ProposalStatus = {}));
/** Type of governance proposal */
export var ProposalType;
(function (ProposalType) {
    ProposalType["Provision"] = "provision";
    ProposalType["Build"] = "build";
    ProposalType["Deploy"] = "deploy";
    ProposalType["Release"] = "release";
    ProposalType["Config"] = "config";
    ProposalType["Scale"] = "scale";
    ProposalType["RotateKey"] = "rotate_key";
    ProposalType["Emergency"] = "emergency";
})(ProposalType || (ProposalType = {}));
/** Type of vote cast */
export var VoteType;
(function (VoteType) {
    VoteType["Approve"] = "approve";
    VoteType["Reject"] = "reject";
    VoteType["Abstain"] = "abstain";
})(VoteType || (VoteType = {}));
//# sourceMappingURL=governance.js.map